import React from "react";
import IconCheck from "../static/images/icon_check_small_green.svg";
import IconX from "../static/images/icon_close_small.svg";
import styled from "styled-components";

interface CheckListItemProps {
  id: string;
  description: string;
  isValid?: boolean;
}

interface CheckListProps {
  id: string;
  rules: any[];
  errors: string[];
  value: string;
}

const CheckListItem: React.FC<CheckListItemProps> = ({ id, description, isValid = false }) => {
  return (
    <ListItem
      aria-label={`${description}.`} //end with period (full stop). prevents 'run-on' sentence like announcement
      className={isValid ? "valid" : "invalid"}
    >
      <img src={isValid ? IconCheck : IconX} alt=""/>
      <p id={id}>
        {description}
      </p>
    </ListItem>
  );
};

const CheckList: React.FC<CheckListProps> = ({ id, rules, errors, value }) => {
  //progress status for non-visual users
  const progress = !(value.length > 0) ? 0 : errors ? 4 - errors?.length : 4;

  return (
    <Checklist id={id}>
      <label
        className={"sr-only"}
        htmlFor="checklist"
      >
        Salasanavaatimukset.
      </label>
      <div id="checklist">
        {rules.map((rule) => (
          <CheckListItem
            key={rule.key}
            id={rule.key}
            description={rule.description}
            isValid={value.length > 0 && !errors?.includes(rule.key)}
          />
        ))}
        <p
          className={"sr-only"}
          aria-live="polite" //aria-live=polite as nonintrusive announcement
        >
          {`${progress} kolmesta vaatimuksesta täytetty`}
        </p>
      </div>
    </Checklist>
  );
};

export default CheckList;

const Checklist = styled.div`
  margin-bottom: 20px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  
  img {
    flex: 0 0 16px;
    margin-right: 5px;
  }
  
  p {
    margin: 0;
  }
  
  &.valid {
    color: #429600;
  }
  
  &.invalid {
    img {
      opacity: .5;
      filter: grayscale(1);
    }
  }
`;